var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-sidebar"},[_c('a-menu',{staticClass:"sidebar-style",attrs:{"defaultSelectedKeys":[_vm.$route.meta.baseCategory || _vm.$route.meta.category],"selectedKeys":[_vm.$route.meta.baseCategory || _vm.$route.meta.category]}},[_vm._l((_vm.sidebarRouter),function(item){return [(!item.meta.hidden)?_c('a-menu-item',{key:item.meta.category,class:{
          'default-color':
            _vm.$route.meta.category !== item.meta.category &&
            _vm.$route.meta.baseCategory !== item.meta.category
        },on:{"click":function($event){return _vm.routerTo(item.name)}}},[_c('span',[_vm._v(_vm._s(_vm.$t(item.meta.title)))])]):_vm._e()]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }